import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <div className="max-w-6xl px-4 mx-auto sm:px-6">
        {/* Top area: Blocks */}
        <div className="grid grid-cols-12 gap-8 py-8 border-t border-gray-200 md:py-12">
          {/* 1st block */}
          <div className="col-span-12 lg:col-span-4">
            <div className="mb-2">
              {/* Logo */}
              <a
                href="https://nebulas.io/"
                target="__blank"
                className="inline-block"
                aria-label="Nebulas"
              >
                <img
                  className="h-12"
                  src={require("../images/nebulas.png")}
                  alt="Nebulas"
                />
              </a>
              <div className="px-4 text-xs text-gray-400">
                星云是自治元网络，专注于处理复杂数据和交互、复杂的协作关系，致力于通过区块链等技术手段，实现让每个人从去中心化协作中公平获益的愿景。
              </div>
            </div>
          </div>

          {/* Nebulas */}
          <div className="col-span-6 px-4 md:col-span-3 lg:col-span-4">
            <h6 className="mb-2 font-medium text-gray-800">星云</h6>
            <ul className="text-sm">
              <li className="mb-2">
                <a
                  href="https://node.nebulas.io/"
                  target="__blank"
                  className="text-gray-600 transition duration-150 ease-in-out hover:text-gray-900"
                >
                  PoD 节点
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://nextdao.io/"
                  target="__blank"
                  className="text-gray-600 transition duration-150 ease-in-out hover:text-gray-900"
                >
                  nextDAO
                </a>
              </li>
              {/* <li className="mb-2">
                <a
                  href="https://go.nebulas.io/"
                  target="__blank"
                  className="text-gray-600 transition duration-150 ease-in-out hover:text-gray-900"
                >
                  Go.Nebulas
                </a>
              </li> */}
              <li className="mb-2">
                <a
                  href="https://explorer.nebulas.io/"
                  target="__blank"
                  className="text-gray-600 transition duration-150 ease-in-out hover:text-gray-900"
                >
                  浏览器
                </a>
              </li>
            </ul>
          </div>

          {/* OKExchain */}
          <div className="col-span-6 px-4 md:col-span-3 lg:col-span-4">
            <h6 className="mb-2 font-medium text-gray-800">OKC</h6>
            <ul className="text-sm">
              <li className="mb-2">
                <a
                  href="https://www.okexcn.com/wallet"
                  className="text-gray-600 transition duration-150 ease-in-out hover:text-gray-900"
                >
                  钱包
                </a>
              </li>
              {/* <li className="mb-2">
                <a
                  href="https://www.okexcn.com/dex/swap"
                  className="text-gray-600 transition duration-150 ease-in-out hover:text-gray-900"
                >
                  Swap
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://www.okexcn.com/dex/spot/trade"
                  className="text-gray-600 transition duration-150 ease-in-out hover:text-gray-900"
                >
                  DEX
                </a>
              </li> */}
              <li className="mb-2">
                <a
                  href="https://www.oklink.com/okexchain"
                  className="text-gray-600 transition duration-150 ease-in-out hover:text-gray-900"
                >
                  浏览器
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom area */}
        <div className="py-4 border-t border-gray-200 md:flex md:items-center md:justify-between md:py-8">
          {/* Social links */}
          <ul className="flex justify-center mb-4 md:order-1 md:ml-4 md:mb-0">
            <li>
              <a
                target="__blank"
                href="https://twitter.com/nebulasio"
                className="flex items-center justify-center text-gray-600 transition duration-150 ease-in-out bg-white rounded-full shadow hover:text-gray-900 hover:bg-white-100"
                aria-label="Twitter"
              >
                <svg
                  className="w-8 h-8 fill-current"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
                </svg>
              </a>
            </li>
            <li className="ml-4">
              <a
                target="__blank"
                href="https://github.com/nebulasio"
                className="flex items-center justify-center text-gray-600 transition duration-150 ease-in-out bg-white rounded-full shadow hover:text-gray-900 hover:bg-white-100"
                aria-label="Github"
              >
                <svg
                  className="w-8 h-8 fill-current"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16 8.2c-4.4 0-8 3.6-8 8 0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4V22c-2.2.5-2.7-1-2.7-1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.3 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6-.2 1.3-.3 2-.3s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.4.6.9.6 1.6v2.2c0 .2.1.5.6.4 3.2-1.1 5.5-4.1 5.5-7.6-.1-4.4-3.7-8-8.1-8z" />
                </svg>
              </a>
            </li>
          </ul>

          {/* Copyrights note */}
          <div className="mr-4 text-sm text-center text-gray-600">
            Made by{" "}
            <a
              className="text-gray-700 hover:underline"
              href="https://nebulas.io/"
            >
              Nebulas.io
            </a>
            . All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
